import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';

function CallStatus(props) {

    const { t } = useTranslation();

    const renderStatus = (data) => {
        let text = "waiting";
        let alarm = "";
        if (props.call.status.startsWith("ACD_RING"))
            text = "ringing";

        if (props.call.status.endsWith("ALARM"))
            alarm = " - " + t("maxqueuetimeexceeded");

        return (<Tooltip style={{ position: "fixed" }} {...data}>{t(text) + alarm}</Tooltip>);
    }


    const getStatus = () => {
        let content = <FontAwesomeIcon className="px-1 text-muted" size="lg" icon={duotone("phone-hangup")} />;

        if (props.call.status.startsWith("DETE")) {
            content = <FontAwesomeIcon style={{ color: "#6610f2" }} size="lg" icon={duotone("phone-arrow-down-left")} />;
        }
        
        if (props.call.status.startsWith("ACD_QUEUE")) {
            content = <FontAwesomeIcon className="text-success" size="lg" icon={duotone("phone-arrow-down-left")} />;
        }

        if (props.call.status.startsWith("ACD_RING")) {
            content = <FontAwesomeIcon className="text-warning" size="lg" icon={duotone("bell-on")} shake/>;
        }


        if (props.call.status.endsWith("ALARM")) {
            content = <FontAwesomeIcon className="text-danger" size="lg" icon={duotone("triangle-exclamation")} />;
        }

        return content;
    }

    return (
        <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderStatus}>
            <div style={{ display: "inline-block" }}>
                {getStatus()}
            </div>
        </OverlayTrigger>
    );
}


export default CallStatus;